// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `quiz-stats {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
@media screen and (max-width: 1601px) {
  quiz-stats .hide-sm {
    display: none;
  }
}
quiz-stats .participants {
  flex-basis: 500px;
  flex-shrink: 1;
}
quiz-stats .details {
  flex-basis: 500px;
  flex-shrink: 0;
}
quiz-stats .no-data {
  background-color: var(--motes-blue);
  color: var(--motes-white);
  padding: 1em;
  border: none;
}
quiz-stats .no-data a {
  color: var(--motes-highlight-color) !important;
}
quiz-stats .overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  transition: 0.5s;
  pointer-events: initial;
  box-sizing: border-box;
  z-index: 2;
}
quiz-stats .overlay:hover {
  background: rgba(0, 0, 0, 0.3);
}
quiz-stats aside {
  width: 300px;
}
quiz-stats aside .challenge-container {
  position: relative;
  cursor: pointer;
}
quiz-stats aside .challenge-container h3 {
  position: absolute;
  color: var(--motes-white);
  top: 0;
  left: 0;
  margin: 0;
  padding: 10px;
  z-index: 3;
}
quiz-stats aside .challenge-container.active::after {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  width: 14px;
  height: 100%;
  background-color: var(--motes-highlight-color);
  content: "";
}
quiz-stats .quiz-stat-details {
  background-color: var(--motes-gold);
  padding: 1em;
  border: none;
}
quiz-stats .quiz-stat-details header {
  padding-left: 1em;
  color: var(--motes-white);
}
quiz-stats .quiz-stat-details h3 {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.4em;
  margin-bottom: 0em;
}
quiz-stats .quiz-stat-details h4 {
  font-size: 1.2em;
  margin-top: 0;
  margin-bottom: 0.4em;
}
quiz-stats .quiz-stat-details h4 svg-icon {
  float: right;
}
quiz-stats .quiz-stat-details main {
  display: flex;
  flex-direction: row;
}
quiz-stats .quiz-stat-details section {
  width: 50%;
}
quiz-stats .quiz-stat-details section > div {
  background-color: rgba(255, 255, 255, 0.6);
  padding: 1em;
  border-radius: var(--border-radius);
  margin: 1em 1em 1em 0;
}
quiz-stats .quiz-stat-details section span.answer {
  float: right;
}
quiz-stats .quiz-stat-details section div.answer {
  display: flex;
  justify-content: space-between;
  padding: 0 0 0.5em 0;
}
quiz-stats .quiz-stat-details section div.answer .right {
  color: var(--motes-green);
}
quiz-stats .quiz-stat-details section div.answer .wrong {
  color: var(--motes-red);
}
quiz-stats .quiz-stat-details div.mini-loading-container {
  background: none;
  padding: 0;
  border: none;
}
quiz-stats .quiz-stat-details.quiz-stat-overview {
  background-color: var(--motes-gray);
}
quiz-stats .quiz-stat-details.quiz-stat-overview section > div {
  background-color: rgba(255, 255, 255, 0.6);
  padding: 1em;
  border-radius: var(--border-radius);
  margin: 1em 1em 1em 0;
}
quiz-stats .table-overflow-wrapper {
  overflow: hidden;
  border-radius: var(--border-radius);
}
quiz-stats ::-webkit-scrollbar {
  z-index: 1;
  background: var(--motes-white);
  position: relative;
}
quiz-stats ::-webkit-scrollbar-thumb {
  background-color: var(--motes-gray);
  border: 3px solid transparent;
}
quiz-stats .table-overflow {
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-color: var(--motes-gray) var(--motes-white);
}
quiz-stats .table-overflow thead,
quiz-stats .table-overflow th {
  position: sticky;
  top: 0;
}
quiz-stats table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0px;
  border-radius: 4px;
  color: var(--motes-dark);
}
quiz-stats table th {
  background-color: white;
  border: 1px solid white;
  padding-right: 10px;
}
quiz-stats table th,
quiz-stats table td {
  padding-left: 8px;
  padding-right: 8px;
}
quiz-stats table tr {
  cursor: pointer;
  height: 40px;
  border: 1px solid var(--motes-dark);
  background-color: var(--motes-white);
}
quiz-stats table tr:nth-child(even) {
  background-color: #ddd;
}
quiz-stats table tr:hover,
quiz-stats table tr:nth-child(even):hover {
  background-color: var(--motes-gray);
}
quiz-stats table tr.active {
  background-color: var(--motes-highlight-color);
}
quiz-stats table tr.active:hover {
  background-color: var(--motes-highlight-color);
}
quiz-stats table .svg-icon {
  font-size: 0.8em;
  min-width: 1em;
  line-height: 1em;
  padding-left: 8px;
}
quiz-stats .opacity-0 {
  opacity: 0;
}
quiz-stats .align-right {
  text-align: right;
}
quiz-stats .align-left {
  text-align: left;
}
quiz-stats .flex {
  display: flex;
}
quiz-stats .justify-start {
  justify-content: flex-start;
}
quiz-stats .justify-end {
  justify-content: flex-end;
}
quiz-stats .items-center {
  align-items: center;
}
quiz-stats .gap-x-8px {
  gap: 8px;
}
quiz-stats .pr-16px {
  padding-right: 16px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/quiz-stats/quiz-stats.component.scss"],"names":[],"mappings":"AAAA;EAOI,aAAA;EACA,8BAAA;EACA,SAAA;AALJ;AAHI;EACI;IACI,aAAA;EAKV;AACF;AAEI;EACI,iBAAA;EACA,cAAA;AAAR;AAGI;EACI,iBAAA;EACA,cAAA;AADR;AAII;EACI,mCAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;AAFR;AAIQ;EACI,8CAAA;AAFZ;AAMI;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;AAJR;AAOI;EACI,8BAAA;AALR;AAQI;EACI,YAAA;AANR;AAQQ;EACI,kBAAA;EACA,eAAA;AANZ;AAQY;EACI,kBAAA;EACA,yBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;AANhB;AAUQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,8CAAA;EACA,WAAA;AARZ;AAYI;EACI,mCAAA;EACA,YAAA;EACA,YAAA;AAVR;AAYQ;EACI,iBAAA;EACA,yBAAA;AAVZ;AAaQ;EACI,+BAAA;EACA,gBAAA;EACA,kBAAA;AAXZ;AAcQ;EACI,gBAAA;EACA,aAAA;EACA,oBAAA;AAZZ;AAcY;EACI,YAAA;AAZhB;AAgBQ;EACI,aAAA;EACA,mBAAA;AAdZ;AAiBQ;EACI,UAAA;AAfZ;AAiBY;EACI,0CAAA;EACA,YAAA;EACA,mCAAA;EACA,qBAAA;AAfhB;AAkBY;EACI,YAAA;AAhBhB;AAmBY;EACI,aAAA;EACA,8BAAA;EACA,oBAAA;AAjBhB;AAmBgB;EACI,yBAAA;AAjBpB;AAoBgB;EACI,uBAAA;AAlBpB;AAuBQ;EACI,gBAAA;EACA,UAAA;EACA,YAAA;AArBZ;AAyBI;EACI,mCAAA;AAvBR;AA0BY;EACI,0CAAA;EACA,YAAA;EACA,mCAAA;EACA,qBAAA;AAxBhB;AA8BI;EACI,gBAAA;EACA,mCAAA;AA5BR;AA+BI;EACI,UAAA;EACA,8BAAA;EACA,kBAAA;AA7BR;AAgCI;EACI,mCAAA;EACA,6BAAA;AA9BR;AAiCI;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qDAAA;AA/BR;AAiCQ;;EAEI,gBAAA;EACA,MAAA;AA/BZ;AAmCI;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;AAjCR;AAmCQ;EACI,uBAAA;EACA,uBAAA;EACA,mBAAA;AAjCZ;AAoCQ;;EAEI,iBAAA;EACA,kBAAA;AAlCZ;AAqCQ;EACI,eAAA;EACA,YAAA;EACA,mCAAA;EACA,oCAAA;AAnCZ;AAsCQ;EACI,sBAAA;AApCZ;AAuCQ;;EAEI,mCAAA;AArCZ;AAwCQ;EACI,8CAAA;AAtCZ;AAyCQ;EACI,8CAAA;AAvCZ;AA0CQ;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAxCZ;AA4CI;EACI,UAAA;AA1CR;AA6CI;EACI,iBAAA;AA3CR;AA8CI;EACI,gBAAA;AA5CR;AA+CI;EACI,aAAA;AA7CR;AAgDI;EACI,2BAAA;AA9CR;AAiDI;EACI,yBAAA;AA/CR;AAkDI;EACI,mBAAA;AAhDR;AAmDI;EACI,QAAA;AAjDR;AAoDI;EACI,mBAAA;AAlDR","sourcesContent":["quiz-stats {\n    @media screen and (max-width: 1601px) {\n        .hide-sm {\n            display: none;\n        }\n    }\n    \n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n\n    .participants {\n        flex-basis: 500px;\n        flex-shrink: 1;\n    }\n\n    .details {\n        flex-basis: 500px;\n        flex-shrink: 0;\n    }\n\n    .no-data {\n        background-color: var(--motes-blue);\n        color: var(--motes-white);\n        padding: 1em;\n        border: none;\n\n        a {\n            color: var(--motes-highlight-color) !important; // Necessary because Bootstrap rule had higher specificity\n        }\n    }\n\n    .overlay {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(0, 0, 0, 0.6);\n        transition: 0.5s;\n        pointer-events: initial;\n        box-sizing: border-box;\n        z-index: 2;\n    }\n\n    .overlay:hover {\n        background: rgba(0, 0, 0, 0.3);\n    }\n\n    aside {\n        width: 300px;\n\n        .challenge-container {\n            position: relative;\n            cursor: pointer;\n\n            h3 {\n                position: absolute;\n                color: var(--motes-white);\n                top: 0;\n                left: 0;\n                margin: 0;\n                padding: 10px;\n                z-index: 3;\n            }\n        }\n\n        .challenge-container.active::after {\n            position: absolute;\n            top: 0;\n            right: 0;\n            z-index: 2;\n            width: 14px;\n            height: 100%;\n            background-color: var(--motes-highlight-color);\n            content: \"\";\n        }\n    }\n\n    .quiz-stat-details {\n        background-color: var(--motes-gold);\n        padding: 1em;\n        border: none;\n\n        header {\n            padding-left: 1em;\n            color: var(--motes-white);\n        }\n\n        h3 {\n            color: rgba(255, 255, 255, 0.9);\n            font-size: 1.4em;\n            margin-bottom: 0em;\n        }\n\n        h4 {\n            font-size: 1.2em;\n            margin-top: 0;\n            margin-bottom: 0.4em;\n\n            svg-icon {\n                float: right;\n            }\n        }\n\n        main {\n            display: flex;\n            flex-direction: row;\n        }\n\n        section {\n            width: 50%;\n\n            > div {\n                background-color: rgba(255, 255, 255, 0.6);\n                padding: 1em;\n                border-radius: var(--border-radius);\n                margin: 1em 1em 1em 0;\n            }\n\n            span.answer {\n                float: right;\n            }\n\n            div.answer {\n                display: flex;\n                justify-content: space-between;\n                padding: 0 0 0.5em 0;\n\n                .right {\n                    color: var(--motes-green);\n                }\n\n                .wrong {\n                    color: var(--motes-red);\n                }\n            }\n        }\n\n        div.mini-loading-container {\n            background: none;\n            padding: 0;\n            border: none;\n        }\n    }\n\n    .quiz-stat-details.quiz-stat-overview {\n        background-color: var(--motes-gray);\n\n        section {\n            > div {\n                background-color: rgba(255, 255, 255, 0.6);\n                padding: 1em;\n                border-radius: var(--border-radius);\n                margin: 1em 1em 1em 0;\n            }\n        }\n    }\n\n    // To enforce border radius on scroll bar\n    .table-overflow-wrapper {\n        overflow: hidden;\n        border-radius: var(--border-radius);\n    }\n\n    ::-webkit-scrollbar {\n        z-index: 1;\n        background: var(--motes-white);\n        position: relative;\n    }\n    \n    ::-webkit-scrollbar-thumb {\n        background-color: var(--motes-gray);\n        border: 3px solid transparent;\n    }\n\n    .table-overflow {\n        max-height: 60vh;\n        overflow-y: auto;\n        overflow-x: hidden;\n        scrollbar-color: var(--motes-gray) var(--motes-white);\n\n        thead,\n        th {\n            position: sticky;\n            top: 0;\n        }\n    }\n\n    table {\n        width: 100%;\n        border-collapse: separate;\n        border-spacing: 0px;\n        border-radius: 4px;\n        color: var(--motes-dark);\n\n        th {\n            background-color: white;\n            border: 1px solid white;\n            padding-right: 10px;\n        }\n\n        th,\n        td {\n            padding-left: 8px;\n            padding-right: 8px;\n        }\n\n        tr {\n            cursor: pointer;\n            height: 40px;\n            border: 1px solid var(--motes-dark);\n            background-color: var(--motes-white);\n        }\n\n        tr:nth-child(even) {\n            background-color: #ddd;\n        }\n\n        tr:hover,\n        tr:nth-child(even):hover {\n            background-color: var(--motes-gray);\n        }\n\n        tr.active {\n            background-color: var(--motes-highlight-color);\n        }\n\n        tr.active:hover {\n            background-color: var(--motes-highlight-color);\n        }\n\n        .svg-icon {\n            font-size: 0.8em;\n            min-width: 1em;\n            line-height: 1em;\n            padding-left: 8px;\n        }\n    }\n\n    .opacity-0 {\n        opacity: 0;\n    }\n\n    .align-right {\n        text-align: right;\n    }\n    \n    .align-left {\n        text-align: left;\n    }\n\n    .flex {\n        display: flex;\n    }\n\n    .justify-start {\n        justify-content: flex-start;\n    }\n    \n    .justify-end {\n        justify-content: flex-end;\n    }\n\n    .items-center {\n        align-items: center;\n    }\n\n    .gap-x-8px {\n        gap: 8px;\n    }\n\n    .pr-16px {\n        padding-right: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
